export default __webpack_public_path__ + "static/media/fauna-index-building-wo-quote.de52b8dc.png";